import "./customnavbar.css";
import { useNavigate, useLocation } from "react-router-dom";
import { MdArrowBack } from 'react-icons/md';
import { FcMenu } from 'react-icons/fc'
import {TbUsers, TbDatabase} from 'react-icons/tb'
import {CgUserAdd, CgHome} from 'react-icons/cg';
import {HiOutlineLogout} from 'react-icons/hi'
import {BiTransfer} from 'react-icons/bi'
import { Fade } from "react-awesome-reveal";
import updown from '../../Assets/ICONS/updown.png'


export function CustomNavbar({ label }) {

    const navigate = useNavigate();

    const auth = JSON.parse(window.localStorage.getItem("auth"));

    const location = useLocation();

    const Logout = () => {
        window.localStorage.clear();
        navigate("/login");
    }


    const openDrawer = () => {
        const drawer = document.querySelector('.side-nav-hover');
        drawer.style.display = 'block';
    }

    const closeDrawer = () => {
        const drawer = document.querySelector('.side-nav-hover');
        drawer.style.display = 'none';
    }

    return (

        <>


            <div className="navbar1">

                <div className="inner">
                    <Fade>
                        <div className="nav_label">
                            <button className="side-nav-btn" onClick={openDrawer} style={{ padding: "5px 10px", marginRight: "10px" }}> <FcMenu /></button><div style={{ marginTop: "5px", color: "green" }} onClick={() => window.history.back()}><MdArrowBack /></div> <div>{label}</div>
                        </div>

                        <div className="user" >
                            Welcome {auth.f_name} <span><img style={{ cursor: "pointer" }} onClick={() => navigate("/getprofile")} src={auth.image} /></span>
                        </div>
                    </Fade>
                </div>


            </div>


            <div className="side-nav-hover">

                <div>

                    <div onClick={closeDrawer} style={{ padding: "20px" }}>X</div>
                    <div className="navs" >

                        <ul>
                            <li onClick={() => navigate('/welcome')}><span className={location.pathname !== "/welcome" ? "holder" : "holder selected"}><span className="icon"><CgHome /></span> <div>Home</div></span></li>
                            {(auth.user_level === "2" || auth.user_level === 2) ? <></> :
                                <li onClick={() => navigate('/customers')} ><span className={location.pathname !== "/customers" ? "holder" : "holder selected"} ><span className="icon"><TbUsers /></span> <div>Customers</div></span></li>
                            }
                            {(auth.user_level === "2" || auth.user_level === 2) ? <></> :
                                <li onClick={() => navigate('/existingAccount')}><span className={location.pathname !== "/existingAccount" ? "holder" : "holder selected"} ><span className="icon"><TbDatabase /></span> <div>Accounts</div></span></li>
                            }
                            <li onClick={() => navigate('/onboard')}><span className={location.pathname !== "/onboard" ? "holder" : "holder selected"} ><span className="icon"><CgUserAdd /></span> <div>Onboard User</div> </span></li>
                            <li onClick={() => navigate('/transaction')}><span className={location.pathname !== "/transaction" ? "holder" : "holder selected"} ><span className="icon"><BiTransfer /></span> <div>Transactions</div> </span></li>
                            <li onClick={()=>navigate('/feedback')}><span className={location.pathname!=="/feedback"?"holder":"holder selected"} ><span className="icon"><img src={updown} width="18px" /></span> <div>Feedback</div> </span></li>

                        </ul>

                    </div>
                    <div className="nav2">
                        <ul>
                            <li onClick={Logout}><span className='holder'><span className="icon"><HiOutlineLogout /></span> <div>Logout</div></span></li>
                        </ul>
                    </div>
                </div>

            </div>
        </>

    );

}